import React from 'react';
import { Trans } from 'react-i18next';
import LandingPage from './scenes/LandingPage';
import RegistrationPage from './scenes/Registration/UserRegistrationPage';
import LoginPage from './scenes/LoginPage';
import ConfirmRegistration from './scenes/Registration/ConfirmRegistration';
import ChangePassword from './scenes/ChangePassword';
import Applications from './scenes/Applications';
import ViewApplication from './forms/Application';
import Application from './scenes/Application';
import RequestResetPassword from './scenes/RequestResetPassword';
import ResetPassword from './scenes/ResetPassword';
import Declaration from './scenes/Declaration';
import TermsAndConditions from './scenes/TermsAndConditions';
import PrivacyPolicy from './scenes/PrivacyPolicy';
import MessageToAgent from './scenes/MessageToAgent';
import SupportingDocuments from './scenes/SupportingDocs';
import Payment from './scenes/Payment';
import PaymentSuccess from './scenes/Payment/PaymentSuccess';
import PaymentFailure from './scenes/Payment/PaymentFailure';
import ShortCodeLogin from './scenes/ShortCodeLogin';
import PaymentInfo from './scenes/Payment/PaymentInfo';

const routes = [
  {
    path: '/',
    component: LandingPage,
    exact: true,
    noAuth: true,
    authRedirect: '/applications',
  },
  {
    path: '/signup',
    component: RegistrationPage,
    noAuth: true,
    authRedirect: '/applications',
  },
  {
    path: '/login',
    component: LoginPage,
    noAuth: true,
    authRedirect: '/applications',
  },
  {
    path: '/signup-confirmed',
    component: ConfirmRegistration,
    noAuth: true,
    authRedirect: '/applications',
  },
  {
    path: '/reset-password',
    component: RequestResetPassword,
    noAuth: true,
    authRedirect: '/applications',
  },
  {
    path: '/reset/finish',
    component: ResetPassword,
    noAuth: true,
  },
  {
    path: '/change-password',
    component: ChangePassword,
    noAuth: true,
    authRedirect: '/applications',
  },
  {
    path: '/short-code/:code/payment-pin/:pin',
    component: ShortCodeLogin,
    noAuth: true,
    authRedirect: '/applications',
  },
  {
    path: '/applications',
    component: Applications,
  },
  {
    path: '/application',
    component: Application,
  },
  {
    path: '/view',
    component: ViewApplication,
  },
  {
    path: '/documents',
    component: SupportingDocuments,
  },
  {
    path: '/declaration',
    component: Declaration,
  },
  {
    path: '/toc',
    component: TermsAndConditions,
    noAuth: true,
  },
  {
    path: '/privacy',
    component: PrivacyPolicy,
    noAuth: true,
  },
  {
    path: '/message/:to',
    component: MessageToAgent,
    props: (routeProps) => ({
      title: (
        <Trans>
          {routeProps.match.params.to === 'officer'
            ? 'respondToVisaOfficer'
            : 'messageToApplicant'}
        </Trans>
      ),
    }),
  },
  {
    path: '/payment/:uuid',
    exact: true,
    component: Payment,
  },
  {
    path: '/payment/:uuid/success',
    component: PaymentSuccess,
  },
  {
    path: '/payment/:uuid/failure',
    component: PaymentFailure,
  },
  {
    path: '/payment/:uuid/info',
    component: PaymentInfo,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/view/routes.js